var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEventIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#FF9FA3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8355_18291)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04961 4.59998C8.29814 4.59998 8.49961 4.80145 8.49961 5.04998V5.79998H11.4996V5.04998C11.4996 4.80145 11.7011 4.59998 11.9496 4.59998C12.1981 4.59998 12.3996 4.80145 12.3996 5.04998V5.79998H13.7496C14.6609 5.79998 15.3996 6.53871 15.3996 7.44998V13.75C15.3996 14.6612 14.6609 15.4 13.7496 15.4H6.24961C5.33834 15.4 4.59961 14.6612 4.59961 13.75V7.44998C4.59961 6.53871 5.33834 5.79998 6.24961 5.79998H7.59961V5.04998C7.59961 4.80145 7.80108 4.59998 8.04961 4.59998ZM7.59961 6.69998H6.24961C5.8354 6.69998 5.49961 7.03576 5.49961 7.44998V8.79998H14.4996V7.44998C14.4996 7.03576 14.1638 6.69998 13.7496 6.69998H12.3996V7.14998C12.3996 7.3985 12.1981 7.59998 11.9496 7.59998C11.7011 7.59998 11.4996 7.3985 11.4996 7.14998V6.69998H8.49961V7.14998C8.49961 7.3985 8.29814 7.59998 8.04961 7.59998C7.80108 7.59998 7.59961 7.3985 7.59961 7.14998V6.69998ZM14.4996 9.69998H5.49961V13.75C5.49961 14.1642 5.8354 14.5 6.24961 14.5H13.7496C14.1638 14.5 14.4996 14.1642 14.4996 13.75V9.69998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8355_18291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventIcon);
export default __webpack_public_path__ + "static/media/event-icon.9ba23cf5054a4c01ac2c932682bd79f5.svg";
export { ForwardRef as ReactComponent };